module.exports = __webpack_public_path__ + "static/media/ico_ticket2.f97b812e.svg";